// Есть ли у браузера сеть и отвечает ли наш сервер. Не связано с сокетом: полоса
// «Нет подключения к интернету» показывается и до входа, «Сервер недоступен» ставит
// реестр обновлений после трёх проб без ответа
const state = {
  online: navigator.onLine,
  serverUnavailable: false,
}

const mutations = {
  setOnline (state, online) {
    state.online = online
  },
  setServerUnavailable (state, unavailable) {
    state.serverUnavailable = unavailable
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
